import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="required-fields-validation"
// Disables the submit button until all required fields have values.
export default class extends Controller {
  static targets = ['required', 'submit']

  connect () {
    this.validateFields()
    this.requiredTargets.forEach(field => {
      field.addEventListener('input', this.validateFields.bind(this))
      field.addEventListener('change', this.validateFields.bind(this))
    })
  }

  validateFields () {
    const allFilled = this.requiredTargets.every(field => {
      const value = field.value || ''
      return value.trim() !== ''
    })

    this.submitTarget.disabled = !allFilled
    if (allFilled) {
      this.submitTarget.classList.remove('opacity-50', 'pointer-events-none')
    } else {
      this.submitTarget.classList.add('opacity-50', 'pointer-events-none')
    }
  }
}
